import type { ApplicationSteps, ImproveFlows, PartialRecord } from 'share/types'
import { type GetApplicationStatusResponse } from 'share/types/api/main'
import { pathnames } from 'utils/constants'

export const getImproveCreditConditionsPaths = (
  { credit_program }: GetApplicationStatusResponse,
  key: ApplicationSteps,
  improveFlows?: Array<ImproveFlows>
) => {
  const paths: {
    DAMU: PartialRecord<ApplicationSteps, string>
    OWN_PROGRAM: PartialRecord<ApplicationSteps, string>
  } = {
    DAMU: {
      GET_DOCS: pathnames['upgrade-conditions'],
      PARSE_ADD_DOCS: pathnames['upgrade-conditions'],
      SCORING: pathnames['upgrade-conditions'],
      DECISION: pathnames.decision
    },
    OWN_PROGRAM: {
      GET_DOCS: pathnames.decision,
      PARSE_ADD_DOCS: pathnames.decision,
      SCORING: pathnames.decision,
      DECISION: pathnames.decision
    }
  }

  if (improveFlows?.includes('IMPROVE_CREDIT_CONDITIONS')) {
    if (credit_program === 'DAMU') {
      return paths['DAMU'][key]
    } else if (credit_program === 'OWN_PROGRAM') {
      return paths['OWN_PROGRAM'][key]
    }
  }

  return paths[credit_program][key]
}

export const getNotaryFlowPaths = (key: ApplicationSteps): string | undefined => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    CREATE_ESTIMATION: pathnames['internal-step-loader'],
    CHOOSING_NOTARY: pathnames.notary,
    DECISION_NOTARY: pathnames.notary
  }

  return paths[key]
}

export const getSpouseFlowPaths = (key: ApplicationSteps) => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    CHECKING_DOCUMENTS: pathnames['pledge-spouse-confirmation'],
    FETCH_SPOUSE_PERSONAL_INFO: pathnames['pledge-spouse-confirmation'],
    SEND_SMS_AND_END_STEP: pathnames['pledge-spouse-confirmation'],
    BIOMETRY_FORENSICS: pathnames['pledge-spouse-confirmation']
  }

  return paths[key]
}
